import styled from "styled-components";

// Navigation Bar
export const NavigationBar = styled.nav`
  background-color: #fff;
  padding: 10px 20px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);

  @media (max-width: 1337px) {
    min-height: 70px;
  }
`;

// Navigation List
export const NavigationList = styled.ul`
  list-style: none;
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;

  @media (max-width: 1537px) {
    display: ${({ $menuOpen }) => ($menuOpen ? "flex" : "none")};
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px 0;
    padding-left: 30px;
  }
`;

// Submenu
export const NavigationSubmenu = styled.ul`
  background-color: white;
  list-style: none;
  position: absolute;
  top: 99%;
  left: 0;
  box-shadow: 0 10px 6px rgba(0, 0, 0, 0.2);

  border-radius: 0 0 15px 15px;
  width: 200px;
  margin-top: 17px;
  z-index: 2;

  @media (max-width: 1537px) {
    display: ${({ $menuOpen }) => ($menuOpen ? "block" : "none")};
    top: 0;
    position: relative;
    margin-top: 0;
    box-shadow: 0 0 0;
  }
`;

// Navigation Link
export const NavigationLink = styled.div`
  color: #003082;
  text-decoration: none;
  padding: 10px;
  font-size: 14px;
  display: inline-block;
  transition: color 0.3s ease-in-out;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;

  &:hover {
    cursor: pointer;
    color: #0073e6;
  }
`;

// Navigation Item
export const NavigationItem = styled.li`
  position: relative;
  font-weight: bold;
`;

// Submenu Item
export const NavigationSubmenuItem = styled.li`
  padding: 18px 20px;

  a {
    color:rgb(0, 48, 130);
    text-decoration: none;
    font-size: 14px;
    font-weight: bold;
    display: block;
    transition: color 0.3s ease-in-out;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select:
    z-index: 10;
   
    &:hover {
      color: #0073e6;
    }
  }
`;

// Mobile Menu Icon (Hamburger Button)
export const NavigationCollapsedIcon = styled.div`
  font-size: 24px;
  display: none;
  cursor: pointer;
  margin-right: 10px;

  @media (max-width: 1537px) {
    display: block;
  }

  @media (max-width: 496px) {
    display: block;
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  @media (max-width: 837px) {
    .NavigationCollapsedIcon {
      position: relative;
      right: 0;
      margin-left: auto;
    }

    &.active {
      right: 230px !important;
    }
  }

  &.active {
    position: absolute;
    right: 510px;
  }
`;

// Right Menu (Search + Appointment
export const NavigationRightMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 496px) {
    position: relative;
  }
`;

// Search Input field style
export const SearchInput = styled.input`
  position: absolute;
  margin-right: 20px;
  right: 290px;
  top: 19px;
  width: 100%;
  border: 1px solid rgb(35, 83, 166);
  border-radius: 8px;
  font-size: 12px;
  max-width: ${({ $searchOpen }) => ($searchOpen ? "200px" : "0px")};
  visibility: ${({ $searchOpen }) => ($searchOpen ? "visible" : "hidden")};
  transition: ${({ $searchOpen }) =>
    $searchOpen
      ? "max-width 0.2s ease-in-out, opacity 0.3s ease-in-out, visibility 0.3s ease-in-out"
      : "none"};
  padding: ${({ $searchOpen }) => ($searchOpen ? "8px" : "0px")};
  padding: 8px;

  &:focus {
    outline: none;
    border-color: rgb(35, 83, 166);
  }
`;

// Search Icon
export const NavigationRightMenuSearch = styled.div`
  margin-right: 20px;

  @media (max-width: 837px) {
    display: none;
  }
`;

// Right Button
export const NavigationRightMenuButton = styled.div`
  background-color: rgb(38, 131, 224);
  padding: 15px 30px;
  color: white;
  border-radius: 30px;
  cursor: pointer;

  @media (max-width: 497px) {
    display: none;
  }
`;

export const NavigationRightMenuButtonLink = styled.a`
  text-decoration: none;
`;
